import { render } from "./department.vue?vue&type=template&id=2ba61a22&scoped=true"
import script from "./department.js?vue&type=script&lang=js"
export * from "./department.js?vue&type=script&lang=js"

import "./department.vue?vue&type=style&index=0&id=2ba61a22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba61a22"]])

export default __exports__